import React, { Component } from "react";
import { observer } from "mobx-react";

import LicenseListRow from "./LicenseListRow";

export default observer(
  class LicensesList extends Component {
    render() {
      const { licensesStore, stores } = this.props;

      const rows = licensesStore.map(license => {
        return (
          <LicenseListRow key={license.Id} license={license} stores={stores} />
        );
      });

      // Internal remark
      let internalRemarkColumn = null;
      if (stores.currentUser.user.isAdmin) {
        internalRemarkColumn = <th>Internal remark</th>;
      }

      // Edit/Delete buttons
      let editButtonColumn = null;
      let deleteButtonColumn = null;
      if (stores.currentUser.user.isAdmin) {
        editButtonColumn = <th className="col-sm-1" />;
        deleteButtonColumn = <th className="col-sm-1" />;
      }

      return (
        <div>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Application</th>
                <th>Type</th>
                <th>Number of licenses</th>
                <th>In use</th>
                <th>End date</th>
                {internalRemarkColumn}
                {editButtonColumn}
                {deleteButtonColumn}
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/LicensesList/index.js